import React from "react";
import { Card, CardGroup, ListGroup, Container } from "react-bootstrap";
import css from "./WhatDo.module.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckDouble } from "@fortawesome/free-solid-svg-icons";
// import "./AboutUs.css";
import {
  WhatWeDoImage1,
  WhatWeDoImage2,
  WhatWeDoImage3,
} from "../../assets/Images";

export default function WhatDo() {
  const servicesArr = [
    {
      title: "Custom Business Software",
      img: WhatWeDoImage1,
      discrib:
        "Tailor-made software that simplifies operations, eliminates manual work, and gives teams a real-time view of the business.",
      point: [
        "Billing & invoicing systems",
        "Inventory & stock management",
        "Dealer & distributor portals",
        "CRM for sales & support",
        "Workflow automation dashboards",
        "Reports, analytics & data export",
      ],
    },

    {
      title: "Web Development",
      img: WhatWeDoImage2,
      discrib:
        "High-performance websites and web applications built to convert — from landing pages to full-scale digital products.",
      point: [
        "Modern front-end (React, SPA, SSR)",
        "Reliable & scalable backend systems",
        "Full-stack development & product ownership",
        "E-commerce with secure payment gateways",
        "Custom CMS & dashboard applications",
        "Performance tuning & long-term support",
      ],
    },
    {
      title: "AI & Chatbot Solutions",
      img: WhatWeDoImage3,
      discrib:
        "Smart conversational AI that answers instantly, automates tasks, and enhances customer experience across your digital channels.",
      point: [
        "Customer service chatbots",
        "Lead-generation & sales assistants",
        "AI integration (WhatsApp, Web, App)",
        "Voice bots & multi-language assistants",
        "Analytics & user insight dashboards",
        "Continuous training & maintenance",
      ],
    },
  ];

  return (
    <section className={css.servicesSection} id="Services">
      <Container className={css.servicesContainer}>
        <div className={css.servicesHeader}>
          <p className={css.sectionTag}>WHAT WE DO</p>
          <h2 className={css.servicesTitle}>
            Digital solutions built for modern businesses.
          </h2>
          <p className={css.servicesSubtitle}>
            From concept to launch, WebZova designs and builds products that
            look sharp, feel smooth, and perform at scale.
          </p>
        </div>

        <CardGroup className={css.servicesGroup}>
          {servicesArr.map((card, key) => (
            <Card key={key} className={css.serviceCard}>
              <Card.Body>
                <div className={css.serviceIconWrap}>
                  <Card.Img
                    src={card.img}
                    alt={card.title}
                    className={css.serviceIcon}
                  />
                </div>
                <Card.Title className={css.serviceTitle}>
                  {card.title}
                </Card.Title>
                <Card.Text className={css.serviceDescription}>
                  {card.discrib}
                </Card.Text>
              </Card.Body>

              <ListGroup className={css.serviceList}>
                {card.point.map((p, index) => (
                  <ListGroup.Item key={index} className={css.serviceListItem}>
                    <span className={css.serviceCheckIcon}>
                      <FontAwesomeIcon icon={faCheckDouble} />
                    </span>
                    <span>{p}</span>
                  </ListGroup.Item>
                ))}
              </ListGroup>
            </Card>
          ))}
        </CardGroup>
      </Container>
    </section>
  );
}
